import { Navigate, Route, Routes } from 'react-router-dom';

import { AdminSection } from '@typings';
import { PATH } from '@constants';
import { userSelector } from '@selectors';
import { useSelector } from '@hooks';

import * as Page from '@pages';
import {
  AdminSectionClusterDetailsLayout,
  AdminSectionLayout,
} from '@components/Layouts';

export const AdminSectionRoutes = () => {
  const { systemRole } = useSelector(userSelector);

  if (!systemRole) {
    return <Navigate replace to={PATH.HOME} />;
  }

  return (
    <Routes>
      <Route element={<AdminSectionLayout />}>
        <Route index element={<Page.AdminSectionUsers />} />

        <Route path="users" element={<Page.AdminSectionUsers />} />
        <Route path="clusters" element={<Page.AdminSectionClusters />} />

        <Route
          path="clusters/:clusterName"
          element={<AdminSectionClusterDetailsLayout />}
        >
          <Route
            path=""
            element={
              <Navigate replace to={AdminSection.ClusterDetailsTab.Nodes} />
            }
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Nodes}
            element={<Page.AdminSectionClusterNodes />}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Resources}
            element={<Page.AdminSectionClusterResources />}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Reports}
            element={<Page.AdminSectionClusterReports />}
          />
          <Route
            path={AdminSection.ClusterDetailsTab.Organizations}
            element={<Page.AdminSectionClusterOrganizations />}
          />
        </Route>

        <Route
          path="organizations"
          element={<Page.AdminSectionOrganizations />}
        />
      </Route>

      <Route
        path="*"
        element={<Navigate replace to={PATH.ADMIN_SECTION_USERS} />}
      />
    </Routes>
  );
};
